var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510,
    height: 510,
    viewBox: "0 0 510 510",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.638 141.691L488.605 212.388C493.973 213.688 499.378 210.39 500.678 205.023L507.34 177.509C508.64 172.141 505.342 166.736 499.974 165.436L192.566 91L8.12782 168.522C3.03642 170.662 0.643816 176.524 2.78382 181.615L13.7528 207.713C15.8928 212.804 21.755 215.197 26.8464 213.057L196.638 141.691Z",
    fill: "url(#paint0_linear_16_10)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.627 247.511L464.444 312.452C469.812 313.753 475.218 310.457 476.519 305.09L483.19 277.578C484.492 272.211 481.196 266.805 475.829 265.503L192.577 196.82L46.0991 258.291C41.0065 260.428 38.6106 266.289 40.7478 271.381L51.7024 297.485C53.8395 302.577 59.7004 304.973 64.793 302.836L196.627 247.511Z",
    fill: "url(#paint1_linear_16_10)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.725 362.498L439.287 419.528C444.663 420.792 450.046 417.459 451.31 412.083L457.789 384.525C459.053 379.149 455.72 373.766 450.344 372.502L192.478 311.873L87.4798 356.059C82.3898 358.201 79.9997 364.064 82.1419 369.155L93.1218 395.247C95.2648 400.338 101.128 402.728 106.218 400.586L196.725 362.498Z",
    fill: "url(#paint2_linear_16_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_10",
    x1: 0.500814,
    y1: 113.701,
    x2: 257.001,
    y2: 282.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89FF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FFFDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16_10",
    x1: 46.0008,
    y1: 217.201,
    x2: 264.001,
    y2: 394.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89FF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FFFDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16_10",
    x1: 29.5008,
    y1: 334.201,
    x2: 306.501,
    y2: 483.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89FF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FFFDA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b981f42a5e68e8bd41b6a3f90a339c28.svg";
export { ForwardRef as ReactComponent };